import React from 'react';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { useAbstractCmsElement } from 'components/cms/hooks/useAbstractCmsElementNew';


function CmsElementDivider(props) {
  const { editMode, index, showElementSettings } = props;

  // CMS Logic via Hook (replaces AbstractCmsElement class logic)
  const {
    shown,
    setShown,
    getMainId,
    getCustomId,
    getParamValue,
    getPaddingClasses,
    elementStyleTag,
    getParallaxData,
    getAppendHtml,
    cssClasses,
    responsiveClasses,
  } = useAbstractCmsElement(props);

  // dnd-kit Sortable Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: index,
    disabled: !editMode,
  });

  // Drag and drop styles
  const dndStyle = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    width: '100%',
    cursor: editMode ? 'move' : 'default',
  };

  // UI Constants
  const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
  const isVisible = getParamValue('visible', true);

  const innerContent = (
    <div
      id={getMainId()}
      className={`
        ms-divider hidden-xs
        ${shownClass}
        ${getPaddingClasses()}
        ${cssClasses}
        ${responsiveClasses}
      `}
      onClick={(e) => editMode && showElementSettings(e, index)}
    >
      {/* Dynamic styles tag for custom animations/CSS */}
      {elementStyleTag}

      <div>{isVisible ? <hr /> : <br />}</div>

      {getAppendHtml()}
    </div>
  );

  const parallaxData = getParallaxData();

  return (
    <div ref={setNodeRef} style={dndStyle} {...attributes} {...listeners}>
      {/*
          Stable wrapper for ScrollTrigger (React 19 Fix).
          Prevents TypeError: Cannot read properties of null (reading 'getBoundingClientRect')
      */}
      <div>
        <CustomScrollTrigger className="cms-overflow-fix" onEnter={() => setShown(true)} {...getCustomId()}>
          {parallaxData ? (
            <Parallax {...parallaxData}>
              {innerContent}
            </Parallax>
          ) : (
            innerContent
          )}
        </CustomScrollTrigger>
      </div>
    </div>
  );
}

export default CmsElementDivider;
